__turbopack_context__.v({
  "acheivername": "psy-optional-module__KRGcrW__acheivername",
  "acheivername1": "psy-optional-module__KRGcrW__acheivername1",
  "acheiverrank": "psy-optional-module__KRGcrW__acheiverrank",
  "acheiverrank1": "psy-optional-module__KRGcrW__acheiverrank1",
  "acheiverrank2": "psy-optional-module__KRGcrW__acheiverrank2",
  "acheiverrank3": "psy-optional-module__KRGcrW__acheiverrank3",
  "acheiverrank4": "psy-optional-module__KRGcrW__acheiverrank4",
  "acheivertitle": "psy-optional-module__KRGcrW__acheivertitle",
  "ansheet": "psy-optional-module__KRGcrW__ansheet",
  "bgboxbg": "psy-optional-module__KRGcrW__bgboxbg",
  "captcha": "psy-optional-module__KRGcrW__captcha",
  "checkboxcontent": "psy-optional-module__KRGcrW__checkboxcontent",
  "classesborder": "psy-optional-module__KRGcrW__classesborder",
  "contactbox": "psy-optional-module__KRGcrW__contactbox",
  "contactboxheight": "psy-optional-module__KRGcrW__contactboxheight",
  "contactsubcontent": "psy-optional-module__KRGcrW__contactsubcontent",
  "gshad": "psy-optional-module__KRGcrW__gshad",
  "img": "psy-optional-module__KRGcrW__img",
  "imgboxbelow": "psy-optional-module__KRGcrW__imgboxbelow",
  "invalidCheck2": "psy-optional-module__KRGcrW__invalidCheck2",
  "mainshead": "psy-optional-module__KRGcrW__mainshead",
  "mbtableheading": "psy-optional-module__KRGcrW__mbtableheading",
  "medalicon": "psy-optional-module__KRGcrW__medalicon",
  "mobhead": "psy-optional-module__KRGcrW__mobhead",
  "mobilemaillinks": "psy-optional-module__KRGcrW__mobilemaillinks",
  "more": "psy-optional-module__KRGcrW__more",
  "normalbutton": "psy-optional-module__KRGcrW__normalbutton",
  "normalbutton2": "psy-optional-module__KRGcrW__normalbutton2",
  "pagemaintitle": "psy-optional-module__KRGcrW__pagemaintitle",
  "paybill": "psy-optional-module__KRGcrW__paybill",
  "paybills": "psy-optional-module__KRGcrW__paybills",
  "redunderline": "psy-optional-module__KRGcrW__redunderline",
  "sectiontitle": "psy-optional-module__KRGcrW__sectiontitle",
  "sectiontitle1": "psy-optional-module__KRGcrW__sectiontitle1",
  "sectiontitle2": "psy-optional-module__KRGcrW__sectiontitle2",
  "subhead": "psy-optional-module__KRGcrW__subhead",
  "tableheading": "psy-optional-module__KRGcrW__tableheading",
  "tablepara": "psy-optional-module__KRGcrW__tablepara",
  "tablepara1": "psy-optional-module__KRGcrW__tablepara1",
  "tablescroll": "psy-optional-module__KRGcrW__tablescroll",
  "toppersupsc": "psy-optional-module__KRGcrW__toppersupsc",
  "viewbutton": "psy-optional-module__KRGcrW__viewbutton",
});
